<template>
    <v-card color="grey lighten-2" height="100%" tile>
        <v-app-bar color="#202945" dark height="100%">
            <v-app-bar-nav-icon @click.stop="drawer = !drawer">
            </v-app-bar-nav-icon>
            <BlockchainStatus></BlockchainStatus>
        </v-app-bar>

        <v-navigation-drawer
            v-model="drawer"
            absolute
            color="#202945"
            dark
            temporary
        >
            <v-list-item>
                <v-list-item-icon>
                    <i class="fa fa-user"></i>
                </v-list-item-icon>
                <v-list-item-content class="align-left">
                    <span>BIENVENIDO</span> <br />
                    <i>{{ user.name }}</i>
                </v-list-item-content>
            </v-list-item>

            <v-divider></v-divider>

            <v-list dense>
                <v-list-item
                    v-if="campañasVisible"
                    :to="{ name: 'Admin - Elecciones' }"
                    link
                >
                    <v-list-item-icon>
                        <i class="fas fa-vote-yea"></i>
                    </v-list-item-icon>
                    <v-list-item-content>
                        Campañas
                    </v-list-item-content>
                </v-list-item>

                <v-list-item
                    v-if="reportsVisible"
                    :class="{ 'menu-item-bottom': !padronVisible }"
                    :to="{ name: 'Admin -reportes' }"
                    class="menu-item menu-item "
                    link
                >
                    <v-list-item-icon>
                        <i class="fas fa-chart-area"></i>
                    </v-list-item-icon>
                    <v-list-item-content>
                        Reportes
                    </v-list-item-content>
                </v-list-item>

                <v-list-item
                    v-if="votosEmitidosVisible"
                    :to="{ name: 'votos-emitidos' }"
                    link
                >
                    <v-list-item-icon>
                        <i class="far fa-file-archive"></i>
                    </v-list-item-icon>
                    <v-list-item-content>
                        Votos Emitidos
                    </v-list-item-content>
                </v-list-item>

                
                <v-list-item
                    v-if="padronVisible"
                    :to="{ name: 'padron' }"
                    class="menu-item menu-item-bottom"
                    link
                >
                    <v-list-item-icon>
                        <i class="fas fa-users"></i>
                    </v-list-item-icon>
                    <v-list-item-content>
                        Padrón Activo
                    </v-list-item-content>
                </v-list-item>

                <v-list-item
                    v-if="emailVisible"
                    :to="{ name: 'emails' }"
                    class="menu-item menu-item-bottom"
                    link
                >
                    <v-list-item-icon>
                        <i class="fas far fa-envelope"></i>
                    </v-list-item-icon>
                    <v-list-item-content>
                        Correos
                    </v-list-item-content>
                </v-list-item>

                <v-list-item
                    v-if="dispositivosVisible"
                    :class="{ 'menu-item-bottom': !padronVisible }"
                    :to="{ name: 'dispositivos' }"
                    link
                >
                    <v-list-item-icon>
                        <i class="fas fa-mobile"></i>
                    </v-list-item-icon>
                    <v-list-item-content>
                        Dispositivos
                    </v-list-item-content>
                </v-list-item>
                <v-list-item
                    v-if="votosDispositivoVisible"
                    :class="{
                        'menu-item-bottom':
                            !padronVisible && !dispositivosVisible,
                    }"
                    :to="{ name: 'voto-por-dispositivo' }"
                    link
                >
                    <v-list-item-icon>
                        <i class="fas fa-file-invoice"></i>
                    </v-list-item-icon>
                    <v-list-item-content>
                        Votos por dispositivo
                    </v-list-item-content>
                </v-list-item>
                <v-list-item
                    v-if="tablesVisible"
                    :class="{
                        'menu-item-bottom':
                            !padronVisible &&
                            !votosDispositivoVisible &&
                            !dispositivosVisible,
                    }"
                    :to="{ name: 'Mesas' }"
                    link
                >
                    <v-list-item-icon>
                        <v-img
                            :src="
                                require('../../assets/icn_voto_mesas_white.svg')
                            "
                            max-height="14px"
                            max-width="19.99px"
                        ></v-img>
                    </v-list-item-icon>
                    <v-list-item-content>
                        Mesas de votación
                    </v-list-item-content>
                </v-list-item>

                <v-list-item
                    v-if="estationesVisibles"
                    :to="{ name: 'Admin - vote stations' }"
                    link
                >
                    <v-list-item-icon>
                        <v-img
                            :src="
                                require('../../assets/icn_voto_mesas_white.svg')
                            "
                            max-height="14px"
                            max-width="19.99px"
                        ></v-img>
                    </v-list-item-icon>
                    <v-list-item-content>
                        Control de mesas
                    </v-list-item-content>
                </v-list-item>
                <v-list-item
                    v-if="prepVisible"
                    :class="{
                        'menu-item-bottom':
                            !padronVisible &&
                            !votosDispositivoVisible &&
                            !dispositivosVisible &&
                            !tablesVisible,
                    }"
                    :to="{ name: 'prep' }"
                    link
                >
                    <v-list-item-icon>
                        <i class="far fa-chart-bar"></i>
                    </v-list-item-icon>
                    <v-list-item-content>
                        PREP
                    </v-list-item-content>
                </v-list-item>

                <v-list-item
                    v-if="prepVisible"
                    :class="{
                        'menu-item-bottom':
                            !padronVisible &&
                            !votosDispositivoVisible &&
                            !dispositivosVisible &&
                            !tablesVisible,
                    }"
                    :to="{ name: 'preview' }"
                    link
                >
                    <v-list-item-icon>
                        <i class="fas fa-chart-line"></i>
                    </v-list-item-icon>
                    <v-list-item-content>
                        Votos vs Votantes
                    </v-list-item-content>
                </v-list-item>

                <v-list-item
                    :class="{
                        'menu-item-bottom':
                            !padronVisible &&
                            !votosDispositivoVisible &&
                            !dispositivosVisible &&
                            !tablesVisible &&
                            !prepVisible,
                    }"
                    :to="{ name: 'planillas' }"
                    link
                >
                    <v-list-item-icon>
                        <i class="fas fa-file-alt"></i>
                    </v-list-item-icon>
                    <v-list-item-content>
                        Planillas
                    </v-list-item-content>
                </v-list-item>
                <v-list-item
                    v-if="prepVisible"
                    :class="{
                        'menu-item-bottom':
                            !padronVisible &&
                            !votosDispositivoVisible &&
                            !dispositivosVisible &&
                            !tablesVisible,
                    }"
                    :to="{ name: 'resultados' }"
                    link
                >
                    <v-list-item-icon>
                        <i class="fas fa-chart-pie"></i>
                    </v-list-item-icon>
                    <v-list-item-content>
                        Resultados
                    </v-list-item-content>
                </v-list-item>
            </v-list>

            <template v-slot:append>
                <v-list-item link @click="logout">
                    <v-list-item-icon>
                        <i class="fas fa-sign-out-alt"></i>
                    </v-list-item-icon>
                    <v-list-item-content>
                        Cerrar sesión
                    </v-list-item-content>
                </v-list-item>
            </template>
        </v-navigation-drawer>

        <v-container fluid>
            <v-row>
                <v-col class="pt-6" cols="12">
                    <v-card light>
                        <transition name="slide" mode="out-in">
                            <router-view
                                :key="$route.name"
                                class="content"
                            ></router-view>
                        </transition>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>

<script>
import Menu from '@/components/admin/Menu';
import BlockchainStatus from '@components/admin/BlockchainStatus';

import { mapGetters } from 'vuex';
import _ from 'lodash';

import {
    ADMIN_TYPE,
    HELPDESK_TYPE,
    SECRETARIA_TYPE,
} from '@/helpers/roleTypes';

export default {
    components: {
        Menu,
        BlockchainStatus,
    },
    data() {
        return {
            drawer: false,
        };
    },
    computed: {
        ...mapGetters({
            user: 'user',
        }),
        mode() {
            return _.get(this, '$store.getters.user.mode');
        },
        contratosVisible() {
            return [ADMIN_TYPE].includes(this.mode);
        },
        reportsVisible() {
            return [ADMIN_TYPE, SECRETARIA_TYPE].includes(this.mode);
        },
        campañasVisible() {
            return [ADMIN_TYPE, SECRETARIA_TYPE].includes(this.mode);
        },
        estationesVisibles() {
            return [ADMIN_TYPE, SECRETARIA_TYPE].includes(this.mode);
        },
        votosVisible() {
            return [ADMIN_TYPE, SECRETARIA_TYPE].includes(this.mode);
        },
        votosEmitidosVisible() {
            return [ADMIN_TYPE].includes(this.mode);
        },
        academicosVisible() {
            return [ADMIN_TYPE, SECRETARIA_TYPE, HELPDESK_TYPE].includes(
                this.mode
            );
        },
        alumnosVisible() {
            return [ADMIN_TYPE, SECRETARIA_TYPE, HELPDESK_TYPE].includes(
                this.mode
            );
        },
        padronVisible() {
            return [ADMIN_TYPE, SECRETARIA_TYPE, HELPDESK_TYPE].includes(
                this.mode
            );
        },
        emailVisible() {
            return [ADMIN_TYPE].includes(
                this.mode
            );
        },
        dispositivosVisible() {
            return [ADMIN_TYPE].includes(this.mode);
        },
        votosDispositivoVisible() {
            return [ADMIN_TYPE, SECRETARIA_TYPE].includes(this.mode);
        },
        tablesVisible() {
            return [ADMIN_TYPE, SECRETARIA_TYPE].includes(this.mode);
        },
        prepVisible() {
            return [ADMIN_TYPE, SECRETARIA_TYPE].includes(this.mode);
        },
        planillasVisible() {
            return [ADMIN_TYPE, SECRETARIA_TYPE, HELPDESK_TYPE].includes(
                this.mode
            );
        },
    },
    methods: {
        logout() {
            this.$store.commit('SET_TOKEN', null);
            this.$router.push({ name: 'Login' });
        },
    },
    mounted() {
        this.$store
            .dispatch('socket/connect')
            .then(result => {
                console.log('CONNECTED TO WS');
            })
            .catch(error => {
                console.error(error);
                this.$store.dispatch('errorMessage', `${error}`);
            });
    },
};
</script>

<style type="scss">
.admin {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100vh;
    background-color: #dadada;
    overflow-x: hidden;
}

.admin-menu {
    min-width: 145px;
    height: 100%;
    box-shadow: 0px 0 5px black;
}

.admin-body {
    flex: 1;
    display: flex;
    flex-direction: column;
    width: calc(100% - 145px);
}

.content {
    height: calc(100% - 34px);
    overflow: auto;
}
</style>
